export default {
  pageNotFound_error: '{{log.user.name}} intentó acceder a una página inexistente',

  mutationUpsertUser: '{{log.user.name}} guardó el usuario: {{log.entity.name}}',

  createUser: '{{log.user.name}} creó el usuario: {{log.entity.name}}',
  updateUser: '{{log.user.name}} actualizó el usuario: {{log.entity.name}}',
  createUser_error: '{{log.user.name}} recibió un error al registrar el usuario: {{log.entity.name}}',
  updateUser_error: '{{log.user.name}} recibió un error al actualizar el usuario: {{log.entity.name}}',
  removeUsers: '{{log.user.name}} eliminó algunos usuarios',
  mutationRemoveUsers: '{{log.user.name}} eliminó algunos usuarios',
  mutationRemoveUsers_error: '{{log.user.name}} recibió un error al eliminar algunos usuarios',
  removeUsers_error: '{{log.user.name}} recibió un error al eliminar algunos usuarios',

  mutationUpsertTrigger: '{{log.user.name}} guardó un trigger',
  mutationRemoveTriggers: '{{log.user.name}} eliminó algunos triggers',
  mutationRemoveTriggers_error: '{{log.user.name}} recibió un error al eliminar algunos triggers',

  createChecklist: '{{log.user.name}} creó el cuestionario: {{log.entity.name}}',
  updateChecklist: '{{log.user.name}} actualizó el cuestionario: {{log.entity.name}}',
  createChecklist_error: '{{log.user.name}} recibió un error al guardar el cuestionario: {{log.entity.name}}',
  updateChecklist_error: '{{log.user.name}} recibió un error al guardar el cuestionario: {{log.entity.name}}',
  removeChecklists: '{{log.user.name}} eliminó algunos cuestionarios',
  removeChecklists_error: '{{log.user.name}} recibió un error al eliminar algunos cuestionarios',

  createServiceOrder: '{{log.user.name}} creó la actividad: {{log.entity.name}}',
  updateServiceOrder: '{{log.user.name}} actualizó la actividad: {{log.entity.name}}',
  mutationUpsertServiceOrder: '{{log.user.name}} guardó la actividad: {{log.entity.name}}',
  createServiceOrder_error: '{{log.user.name}} recibió un error al guardar la actividad: {{log.entity.name}}',
  updateServiceOrder_error: '{{log.user.name}} recibió un error al guardar la actividad: {{log.entity.name}}',
  removeServiceOrders: '{{log.user.name}} eliminó algunas actividades',
  removeServiceOrders_error: '{{log.user.name}} recibió un error al eliminar algunas actividades',
  saveServiceOrderReplies: '{{log.user.name}} alteró las respuestas de la actividad: {{log.entity.name}}',
  saveServiceOrderReplies_error:
    '{{log.user.name}} recibió un error al alterar las respuestas de la actividad: {{log.entity.name}}',

  createActionPlan: '{{log.user.name}} creó un plan de acción',
  createActionPlan_error: '{{log.user.name}} recibió un error al crear un plan de acción',

  updateServiceOrderStatus_execution: '{{log.user.name}} actualizó el estado de la actividad a ejecución',
  updateServiceOrderStatus_execution_error:
    '{{log.user.name}} recibió un error al actualizar el estado de la actividad a ejecución',
  updateServiceOrderStatus_pause: '{{log.user.name}} actualizó el estado de la actividad a pausada',
  updateServiceOrderStatus_pause_error:
    '{{log.user.name}} recibió un error al actualizar el estado de la actividad a pausada',
  updateServiceOrderStatus_completed: '{{log.user.name}} actualizó el estado de la actividad a completada',
  updateServiceOrderStatus_completed_error:
    '{{log.user.name}} recibió un error al actualizar el estado de la actividad a completada',
  updateServiceOrderStatus_approved: '{{log.user.name}} actualizó el estado de la actividad a aprobada',
  updateServiceOrderStatus_approved_error:
    '{{log.user.name}} recibió un error al actualizar el estado de la actividad a aprobada',
  updateServiceOrderStatus_disapproved: '{{log.user.name}} actualizó el estado de la actividad a rechazada',
  updateServiceOrderStatus_disapproved_error:
    '{{log.user.name}} recibió un error al actualizar el estado de la actividad a rechazada',
  updateServiceOrderStatus_canceled: '{{log.user.name}} actualizó el estado de la actividad a cancelada',
  updateServiceOrderStatus_canceled_error:
    '{{log.user.name}} recibió un error al actualizar el estado de la actividad a cancelada',

  savePlace: '{{log.user.name}} guardó un local/persona',
  savePlace_plural: '{{log.user.name}} guardó {{count}} locales/personas',
  savePlace_error: '{{log.user.name}} recibió un error al guardar locales/personas',
  removePlaces: '{{log.user.name}} eliminó algunos locales/personas',
  removePlaces_error: '{{log.user.name}} recibió un error al eliminar algunos locales/personas',

  createBucket: '{{log.user.name}} creó el lote de qrcodes: {{log.entity.name}}',
  updateBucket: '{{log.user.name}} actualizó el lote de qrcodes: {{log.entity.name}}',
  createBucket_error: '{{log.user.name}} recibió un error al guardar el lote de qrcodes: {{log.entity.name}}',
  updateBucket_error: '{{log.user.name}} recibió un error al guardar el lote de qrcodes: {{log.entity.name}}',
  removeBuckets: '{{log.user.name}} eliminó algunos lotes de qrcodes',
  removeBuckets_error: '{{log.user.name}} recibió un error al eliminar algunos lotes de qrcodes',

  createSegment: '{{log.user.name}} creó la segmentación: {{log.entity.name}}',
  updateSegment: '{{log.user.name}} actualizó la segmentación: {{log.entity.name}}',
  createSegment_error: '{{log.user.name}} recibió un error al guardar la segmentación: {{log.entity.name}}',
  updateSegment_error: '{{log.user.name}} recibió un error al guardar la segmentación: {{log.entity.name}}',
  removeSegments: '{{log.user.name}} eliminó algunas segmentaciones',
  removeSegments_error: '{{log.user.name}} recibió un error al eliminar algunas segmentaciones',

  createForm: '{{log.user.name}} creó el formulario: {{log.entity.name}}',
  updateForm: '{{log.user.name}} actualizó el formulario: {{log.entity.name}}',
  createForm_error: '{{log.user.name}} recibió un error al crear el formulario: {{log.entity.name}}',
  updateForm_error: '{{log.user.name}} recibió un error al actualizar el formulario: {{log.entity.name}}',
  removeForm: '{{log.user.name}} eliminó algunos formularios',
  removeForm_error: '{{log.user.name}} recibió un error al eliminar algunos formularios',
  answerForm: 'Una nueva respuesta del form: {{log.entity.name}} fue recibida',
  answerForm_error: 'Ocurrió un error al responder el form: {{log.entity.name}}',

  enableModule: '{{log.user.name}} activó el módulo: {{log.entities.0.name}} | {{log.entities.1.name}}',
  disableModule: '{{log.user.name}} desactivó el módulo: {{log.entities.0.name}} | {{log.entities.1.name}}',
  updateModule: '{{log.user.name}} actualizó el módulo: {{log.entities.0.name}} | {{log.entities.1.name}}',
  enableModule_error:
    '{{log.user.name}} recibió un error al activar el módulo: {{log.entities.0.name}} | {{log.entities.1.name}}',
  disableModule_error:
    '{{log.user.name}} recibió un error al desactivar el módulo: {{log.entities.0.name}} | {{log.entities.1.name}}',
  updateModule_error:
    '{{log.user.name}} recibió un error al actualizar el módulo: {{log.entities.0.name}} | {{log.entities.1.name}}',

  importUser: '{{log.user.name}} solicitó una importación de usuarios',
  importRefund: '{{log.user.name}} solicitó una importación de reembolsos',
  importPlace: '{{log.user.name}} solicitó una importación de locales/personas',
  importForm: '{{log.user.name}} solicitó una importación de un formulario',
  importChecklist: '{{log.user.name}} solicitó una importación de cuestionarios',
  importServiceOrder: '{{log.user.name}} solicitó una importación de actividades',

  exportUsers: '{{log.user.name}} solicitó una exportación de usuarios',
  exportUser: '$t(exportUser)',
  exportRefunds: '{{log.user.name}} solicitó una exportación de reembolsos',
  exportRefund: '$t(exportRefunds)',
  exportPlaces: '{{log.user.name}} solicitó una exportación de locales/personas',
  exportPlace: '$t(exportPlaces)',
  exportForm: '{{log.user.name}} solicitó una exportación de un formulario',
  exportChecklists: '{{log.user.name}} solicitó una exportación de cuestionarios',
  exportChecklist: '$t(exportChecklists)',
  exportServiceOrders: '{{log.user.name}} solicitó una exportación de actividades',
  exportServiceOrder: '$t(exportServiceOrders)',

  login: '{{log.user.name}} se conectó en {{log.origin}}',
  login_error: 'Email: {{log.entity.name}} no pudo conectarse en {{log.origin}}',
  logout: '{{log.user.name}} se desconectó en {{log.origin}}',
  forceLogout_warn: '{{log.user.name}} fue forzado a desconectarse en {{log.origin}}',
  access: '{{log.user.name}} se accedió en {{log.origin}}',

  addLog_warn: '{{log.user.name}} intentó guardar un log pero falló',
  apiCall_error:
    '{{log.user.name}} recibió un error al llamar a la api: {{log.data.payload.method}} /{{log.data.payload.path}}',

  monitorApiCall: `{{log.user.name}} llamó a la api: {{log.data.payload.method}} /{{log.data.payload.path}}`,

  initSync: '{{log.user.name}} inició una sincronización',
  endSync: '{{log.user.name}} finalizó una sincronización',

  fetchSyncSegment: '{{log.user.name}} recibió {{log.data.response.result.rowsLength}} segmentaciones por sync',
  fetchSyncChecklist: '{{log.user.name}} recibió {{log.data.response.result.rowsLength}} cuestionarios por sync',
  fetchSyncPlace: '{{log.user.name}} recibió {{log.data.response.result.rowsLength}} locales/personas por sync',
  fetchSyncUser: '{{log.user.name}} recibió {{log.data.response.result.rowsLength}} usuarios por sync',
  fetchSyncStatus: '{{log.user.name}} recibió {{log.data.response.result.rowsLength}} estados por sync',
  fetchSyncCompany: '{{log.user.name}} recibió {{log.data.response.result.rowsLength}} empresas por sync',
  fetchSyncPlaceLevel: '{{log.user.name}} recibió {{log.data.response.result.rowsLength}} niveles de locales por sync',
  fetchSyncField:
    '{{log.user.name}} recibió {{log.data.response.result.rowsLength}} configuraciones de campos adicionales por sync',
  fetchSyncServiceOrder: '{{log.user.name}} recibió {{log.data.response.result.rowsLength}} actividades por sync',
  fetchSyncLevel:
    '{{log.user.name}} recibió {{log.data.response.result.rowsLength}} configuración de niveles de locales por sync',
  requestSyncServiceOrder: '{{log.user.name}} envió una actividad por sync',
  requestSyncReply: '{{log.user.name}} envió las respuestas de una actividad por sync',
  requestSyncEvent: '{{log.user.name}} envió los eventos de una actividad por sync',
  clearDB_warn: '{{log.user.name}} borró todos los datos de la app mobile',
  clearSyncPending_warn: '{{log.user.name}} forzó eliminar todas las pendencias de sync',

  saved: 'guardado',
  stacktrace: 'Stacktrace'
}
